import './index.css';

export default {
  name: 'Atree',
  props: {
    id: { type: String, default: () => (`a-tree-${Math.random().toString().substring(2)}`) },
    string: { type: Boolean, default: () => true },
    loading: { type: Boolean, default: () => false },
    accordion: { type: Boolean, default: () => false },
    filter: { type: Boolean, default: () => true },
    showCheckbox: { type: Boolean, default: () => true },
    checkStrictly: { type: Boolean, default: () => false },
    iconClass: { type: String, default: () => '' },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    nodeKey: { type: String, default: () => 'id' },
    childrenKey: { type: String, default: () => 'children' },
    labelKey: { type: String, default: () => 'name' },
    horizontal: { type: Boolean, default: () => false },
    defaultExpandAll: { type: Boolean, default: () => true },
    expandOnClickNode: { type: Boolean, default: () => false },
    checkOnClickNode: { type: Boolean, default: () => true },
    autoExpandParent: { type: Boolean, default: () => true },
    defaultCheckedKeys: { type: Array | String, default: () => null },
    defaultSelectedRow: { type: Object, default: () => ({}) },
    draggable: { type: Boolean, default: () => false },
  },
  data() {
    return {
      props: {
        children: this.childrenKey,
        label: this.labelKey,
      },
      checkedKeys: [],
      keyword: '',
    }
  },
  watch: {
    data() { this.create() },
    items() { this.create() },
    config() { this.create() },
    option() { this.create() },
    options() { this.create() },
    defaultCheckedKeys() {
      this.create();
    },
    keyword(keyword) {
      this.$refs && (this.$refs.aTree && (this.$refs.aTree.filter(keyword)));
    },
  },
  mounted() {
    this.create();
  },
  methods: {
    search(value, data) {
      if (!value) return true;
      return data[this.labelKey].indexOf(value) != -1;
    },
    create() {
      if (this.defaultCheckedKeys) {
        const keys = this.defaultCheckedKeys;
        const data = (keys && (typeof keys === 'string')) ? keys.split(',') : keys;
        this.checkedKeys = (data && (data.length > 0)) ? (data.filter((a) => (parseInt(a) !== 0))) : [];
        this.$nextTick(() => {
          this.$refs['aTree'] && (this.checkedKeys.forEach(a => this.$refs['aTree'].setChecked(a, true, false)));
        });
      }
    },
    check(object = {}, { checkedNodes = [], checkedKeys = [], halfCheckedNodes = [], halfCheckedKeys = [] }) {
      const values = [...checkedKeys, ...halfCheckedKeys];
      const value = this.string ? values.join() : values;
      this.$emit('input', value);
      this.$emit('check', value);
      this.$emit('choose', value);
    },
    nodeClick(row) {
      this.$emit('click', row);
      this.$emit('select', row);
      this.$emit('nodeClick', row);
    },
    drag(node) {
      this.$emit('drag', node);
    },
    drop(draggingNode, dropNode, type) {
      this.$emit('drop', { draggingNode, dropNode, type });
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <div id={this.id} class={['a-tree', (this.horizontal ? 'horizontal' : null)]} v-loading={this.loading}>
        {this.filter && (<el-input class="filter" size="small" placeholder="输入关键字进行过滤" v-model={this.keyword} />)}
        {data.length > 0 && (
          <el-tree
            ref="aTree"
            accordion={this.accordion}
            show-checkbox={this.showCheckbox}
            check-strictly={this.checkStrictly}
            iconClass={this.iconClass}
            data={data}
            node-key={this.nodeKey}
            props={this.props}
            default-expand-all={this.defaultExpandAll}
            expand-on-click-node={this.expandOnClickNode}
            check-on-click-node={this.checkOnClickNode}
            auto-expand-parent={this.autoExpandParent}
            on-node-click={this.nodeClick}
            on-check={this.check}
            default-expanded-keys={this.checkedKeys}
            draggable={this.draggable}
            on-allow-drag={this.drag}
            on-allow-drop={this.drop}
            filter-node-method={this.search}
            {...{ attrs }}
          />
        )}
      </div>
    );
  },
}